(function () {
  'use strict';

  var CHECKOUT_SELECTOR =
    "input[name='checkout'], button[name='checkout'], [href$='checkout'], input[name='goto_pp'], button[name='goto_pp'], input[name='goto_gc'], button[name='goto_gc'], .additional-checkout-button, .google-wallet-button-holder, .amazon-payments-pay-button, .shopify-payment-button";

  function getElement(target) {
    if (!target) return null;
    if (target.nodeType === 3) return target.parentElement;
    return target;
  }

  function isCheckoutTarget(target) {
    var el = getElement(target);
    if (!el || typeof el.closest !== 'function') return false;
    return Boolean(el.closest(CHECKOUT_SELECTOR));
  }

  function init() {
    var popup = document.getElementById('b2b-checkout-popup');
    if (!popup) return;

    function openPopup() {
      if (popup.parentElement !== document.body) {
        document.body.appendChild(popup);
      }
      popup.setAttribute('aria-hidden', 'false');
      document.body.classList.add('b2b-popup-open');
    }

    function closePopup() {
      popup.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('b2b-popup-open');
    }

    function blockAndShow(event) {
      event.preventDefault();
      event.stopPropagation();
      if (typeof event.stopImmediatePropagation === 'function') {
        event.stopImmediatePropagation();
      }
      openPopup();
    }

    document.addEventListener(
      'click',
      function (event) {
        if (!isCheckoutTarget(event.target)) return;
        blockAndShow(event);
      },
      true
    );

    document.addEventListener(
      'submit',
      function (event) {
        var form = event.target;
        if (!form || typeof form.querySelector !== 'function') return;
        if (!form.querySelector(CHECKOUT_SELECTOR)) return;
        blockAndShow(event);
      },
      true
    );

    popup.addEventListener('click', function (event) {
      var el = getElement(event.target);
      if (event.target === popup || (el && el.hasAttribute && el.hasAttribute('data-b2b-popup-close'))) {
        closePopup();
      }
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && popup.getAttribute('aria-hidden') === 'false') {
        closePopup();
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
